/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));
export default function LTTabs(props) {
  const classes = useStyles();

  const { tabValue, handleChangeTabValue } = props;
  return (
    <>
      <div data-testid="create-letter-template-tabs" className={classes.root}>
        <AppBar position="static">
          <Tabs
            data-testid="create-letter-template-tabs-area"
            value={tabValue}
            onChange={(e, a) => handleChangeTabValue(a)}
            color="red"
            style={{ color: 'red' }}
          >
            {tabValue === 'Body' && (
              <Tab
                style={{ textTransform: 'capitalize' }}
                value="Body"
                label="Body"
                tabIndex={0}
              />
            )}
            {tabValue === 'HeaderFooter' && (
              <Tab
                style={{ textTransform: 'capitalize' }}
                value="HeaderFooter"
                label="Header/Footer"
                tabIndex={0}
              />
            )}
            {tabValue === 'Preview' && (
              <Tab
                style={{ textTransform: 'capitalize' }}
                value="Preview"
                label="Preview"
                tabIndex={0}
              />
            )}
            {tabValue === 'ModifyLetter' && (
              <Tab
                style={{ textTransform: 'capitalize' }}
                value="ModifyLetter"
                label="Modify Letter"
                tabIndex={0}
              />
            )}
          </Tabs>
        </AppBar>
      </div>
    </>
  );
}
